import React from 'react';
import { AppState } from '../../../../types/store';
import { connect } from 'react-redux';
import { getModuleData } from '../../../selectors/modules';
import {
  ExhibitionistSlideFitMode,
  ExhibitionistViewMode,
} from '../../../../types/modules';
import { GallectionType } from '../../../../types/gallection';

export interface WithModuleDataProps {
  moduleData: {
    sourceType: GallectionType;
    viewMode: ExhibitionistViewMode;
    slideImageFit: ExhibitionistSlideFitMode;
  };
}

export const withModuleData = <BaseProps extends WithModuleDataProps>(
  Component: React.ComponentType<BaseProps>
) => {
  const mapStateToProps = (state: AppState, ownProps) => ({
    moduleData: getModuleData(state, ownProps.moduleId),
  });

  type HocProps = ReturnType<typeof mapStateToProps>;

  class ComponentWithModuleData extends React.Component<HocProps> {
    render() {
      return <Component {...(this.props as BaseProps)} />;
    }
  }

  return connect(mapStateToProps)(ComponentWithModuleData);
};

export default withModuleData;
